import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const createEodManifestForIds = {
  name: "createEodManifestForIds" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(z.string()),
    carrier: createEnum(Carriers),
  }),
  output: z.object({ success: z.boolean() }),
};
